import { useCallback } from 'react';
import { useToggle, useLatest } from 'react-use';
import { useSyncDeviceMutation } from 'apis/cm';

function useRFValues(device, options) {
  const deviceRef = useLatest(device);
  const [open, toggleOpen] = useToggle(false);
  const mutation = useSyncDeviceMutation(options);
  const { mutate, isLoading } = mutation;
  const handleRefresh = useCallback(() => {
    const { deviceId } = deviceRef.current;
    mutate({ deviceId });
  }, [deviceRef, mutate]);

  return {
    mutation,
    trigger: { onClick: toggleOpen },
    dialog: { open, device, refreshing: isLoading, onRefresh: handleRefresh, onClose: toggleOpen }
  };
}

export default useRFValues;
